import { t } from "@/i18n-js/instance";
import { Icon } from "@/react/components/shared/Icon";
import { Button } from "@/react/components/shared/uikit/Button";
import { Dropdown } from "@/react/components/shared/uikit/Dropdown";
import { Typography } from "@/react/components/shared/uikit/Typography";
import { Renderer } from "./Renderer";
import { useControlsDropdownContext } from "./context";

const i18nBase = "members_directory.controls_dropdown";

export const CustomDropdown = () => {
  const { setCurrentComponent } = useControlsDropdownContext();

  return (
    <Dropdown
      button={
        <Button variant="secondary" className="flex items-center gap-2">
          <Icon type="16-settings-slider" size={16} />
          <Typography.LabelSm weight="medium" color="text-dark">
            {t(`${i18nBase}.title`)}
          </Typography.LabelSm>
        </Button>
      }
      menuItemsClassName="!w-[280px] !p-2"
      shouldAddDivider
      size="large"
      onToggle={open => {
        if (!open) {
          setCurrentComponent("root");
        }
      }}
    >
      <Renderer />
    </Dropdown>
  );
};
